exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-fade-enter-active[data-v-246b4802]{transition:all .45s ease}.slide-fade-leave-active[data-v-246b4802]{transition:all 0s cubic-bezier(1,.5,.8,1)}.slide-fade-enter[data-v-246b4802],.slide-fade-leave-to[data-v-246b4802]{transform:translateY(70px);opacity:0}", ""]);

// exports
